import v3ApiClient from "./client";

const BOARD_PATH = "/v3/airport-departure/board";

const cleanParams = (params = {}) => {
    const cleaned = {};
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }
        cleaned[key] = value;
    });
    return cleaned;
};

function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isBoardPayload(value) {
    return (
        isRecord(value) &&
        Array.isArray(value.airports) &&
        isRecord(value.selected) &&
        isRecord(value.meta) &&
        isRecord(value.summary) &&
        Array.isArray(value.flights) &&
        !("delayed" in (value.summary || {}))
    );
}

export async function getAirportDepartureBoard(params = {}) {
    const response = await v3ApiClient.get(BOARD_PATH, { params: cleanParams(params) });
    const payload = response?.data;
    if (!isBoardPayload(payload)) {
        throw new Error("机场离港观察看板响应契约无效");
    }
    return payload;
}

export const airportDepartureApi = {
    getBoard: getAirportDepartureBoard,
};

export default airportDepartureApi;
